var _style, _path, _path2, _circle, _path3, _circle2, _polygon, _path4, _path5, _path6, _path7, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _g2, _polygon4, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataVisualization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      width: 188
    },
    xmlSpace: "preserve",
    "data-imageid": "data-visualization-61",
    imageName: "Data Visualization",
    className: "illustrations_image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_data-visualization-61{fill:#FFFFFF;}\r\n\t.st1_data-visualization-61{fill:#474747;}\r\n\t.st2_data-visualization-61{fill:#68E1FD;}\r\n\t.st3_data-visualization-61{fill:#D1D3D4;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Big_Eye_data-visualization-61"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0_data-visualization-61",
    d: "M399.8,244.2c0,0-65.8,54.9-146.8,54.9s-146.8-54.9-146.8-54.9s65.8-54.9,146.8-54.9S399.8,244.2,399.8,244.2z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M252.9,299.8c-80.4,0-146.6-54.5-147.3-55.1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.4,0.3-0.5 c0.7-0.6,66.9-55.1,147.3-55.1s146.6,54.5,147.3,55.1c0.2,0.1,0.3,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5 C399.5,245.3,333.3,299.8,252.9,299.8z M107.2,244.2c7.1,5.7,70.1,54.2,145.7,54.2s138.6-48.5,145.7-54.2 c-7.1-5.7-70.1-54.2-145.7-54.2S114.3,238.5,107.2,244.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2_data-visualization-61 targetColor",
    cx: 252.9,
    cy: 244.2,
    r: 48.7,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1_data-visualization-61",
    cx: 252.9,
    cy: 244.2,
    r: 30.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M252.9,275.5c-17.3,0-31.3-14-31.3-31.3s14-31.3,31.3-31.3s31.3,14,31.3,31.3 C284.2,261.4,270.2,275.4,252.9,275.5z M252.9,214.3c-16.5,0-29.9,13.4-29.9,29.9c0,16.5,13.4,29.9,29.9,29.9 c16.5,0,29.9-13.4,29.9-29.9C282.8,227.7,269.4,214.3,252.9,214.3L252.9,214.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0_data-visualization-61",
    cx: 263.1,
    cy: 233.7,
    r: 10.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_line_chart_data-visualization-61"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0_data-visualization-61",
    points: "359.2,312.6 335.1,293.6 339.6,312.6 326.7,312.6 326.7,385.3 450.7,385.3 450.7,312.6 \t"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M450.7,386h-124c-0.4,0-0.7-0.3-0.7-0.7v0v-72.7c0-0.4,0.3-0.7,0.7-0.7h0h12l-4.3-18.2c-0.1-0.3,0-0.6,0.3-0.8 c0.2-0.2,0.6-0.2,0.8,0l23.9,18.9h91.2c0.4,0,0.7,0.3,0.7,0.7v0v72.7C451.4,385.6,451.1,386,450.7,386 C450.7,386,450.7,386,450.7,386z M327.4,384.6H450v-71.3h-90.8c-0.2,0-0.3-0.1-0.4-0.1l-22.5-17.8l4,17.1c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.3,0.3-0.5,0.3h-12.2L327.4,384.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M438.9,372.7h-99.6c-0.4,0-0.7-0.3-0.7-0.7v0v-24.7c0-0.2,0.1-0.4,0.3-0.6c6.5-4.6,17.8-7.9,34.4,2.7 c8,5.1,13.3-0.3,19.9-7.1c5-5.2,10.8-11.1,19-13.6c19.2-6,27.2,11,27.3,11.1c0,0.1,0.1,0.2,0.1,0.3V372 C439.6,372.4,439.3,372.7,438.9,372.7C438.9,372.7,438.9,372.7,438.9,372.7z M340,371.3h98.2v-31c-0.8-1.6-8.2-15.6-25.6-10.3 c-7.9,2.4-13.5,8.2-18.4,13.3c-6.8,7-12.7,13.1-21.7,7.3c-15.7-10-26.3-7.2-32.6-3L340,371.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M377.8,325.2h-38.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h38.5c0.4,0,0.7,0.3,0.7,0.7 C378.5,324.8,378.2,325.2,377.8,325.2z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M377.8,329.9h-38.5c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h38.5c0.4,0,0.7,0.3,0.7,0.7 C378.5,329.6,378.2,329.9,377.8,329.9z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M368.4,334.6h-29.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h29.1c0.4,0,0.7,0.3,0.7,0.7 C369.1,334.3,368.7,334.6,368.4,334.6z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M379,372.7c-0.4,0-0.7-0.3-0.7-0.7v0v-19.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7V372 C379.7,372.4,379.4,372.7,379,372.7C379,372.7,379,372.7,379,372.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M418.6,370.9c-0.4,0-0.7-0.3-0.7-0.7v0v-42c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v42 C419.3,370.6,419,370.9,418.6,370.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_pie_chart_2_data-visualization-61"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0_data-visualization-61",
    points: "197.5,307.5 165.9,314.4 165.9,292.8 43.4,292.8 43.4,373.8 165.9,373.8 165.9,328.5 \t"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M165.9,374.5H43.4c-0.4,0-0.7-0.3-0.7-0.7l0,0v-80.9c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h122.5 c0.4,0,0.7,0.3,0.7,0.7l0,0v20.7l30.8-6.7c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.3-0.1,0.6-0.3,0.7l-31.3,20.7v44.9 C166.6,374.2,166.3,374.5,165.9,374.5z M44.1,373.1h121.1v-44.6c0-0.2,0.1-0.5,0.3-0.6L194,309l-28,6.1c-0.2,0-0.4,0-0.6-0.1 c-0.2-0.1-0.3-0.3-0.3-0.5v-20.9H44.1L44.1,373.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M85.1,331H70.7c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0.5-7.4,3.4-14.4,8.3-20c1-1.1,2-2.1,3.1-3.1 c5.6-4.9,12.6-7.9,20-8.3c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v14.4c0,0.4-0.3,0.6-0.6,0.7c-8.3,1-14.8,7.5-15.8,15.8 C85.7,330.7,85.4,331,85.1,331z M71.5,329.6h13c1.3-8.4,7.9-15,16.3-16.3v-13c-6.8,0.6-13.3,3.4-18.5,7.9l0,0 C76.1,313.7,72.2,321.3,71.5,329.6L71.5,329.6z M81.9,307.6L81.9,307.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M103.7,366.2c-0.7,0-1.5,0-2.2-0.1c-7.4-0.5-14.4-3.4-20-8.3c-1.1-1-2.1-2-3.1-3.1c-4.9-5.6-7.9-12.6-8.3-20 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h14.4c0.4,0,0.7,0.3,0.7,0.6c0.4,3.3,1.7,6.5,3.8,9.1c0.9,1.1,1.8,2.1,2.9,2.9 c6.5,5.2,15.8,5.2,22.3,0c1.1-0.9,2.1-1.8,2.9-2.9c2.1-2.6,3.4-5.8,3.8-9.1c0.1-0.7,0.1-1.4,0.1-2.1c0-0.7,0-1.4-0.1-2.1 c-0.4-3.3-1.7-6.5-3.8-9.1c-0.2-0.3-0.2-0.7,0-0.9l10.2-10.2c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c4.9,5.6,7.8,12.6,8.3,20c0.1,0.7,0.1,1.5,0.1,2.2s0,1.5-0.1,2.2c-0.5,7.4-3.4,14.5-8.3,20c-1,1.1-2,2.1-3.1,3.1 c-5.6,4.9-12.6,7.9-20,8.3C105.2,366.2,104.4,366.2,103.7,366.2z M71.5,335.4c0.6,6.8,3.4,13.3,7.9,18.5c0.9,1.1,1.9,2.1,3,3 c5.3,4.7,12.1,7.6,19.2,8c1.4,0.1,2.8,0.1,4.2,0c7.1-0.5,13.9-3.3,19.2-8c1.1-0.9,2.1-1.9,3-3c4.7-5.3,7.6-12.1,8-19.2 c0.1-0.7,0.1-1.4,0.1-2.1s0-1.4-0.1-2.1l0,0c-0.4-6.9-3-13.4-7.5-18.6l-9.3,9.2c2,2.7,3.3,5.9,3.7,9.3c0.1,0.7,0.1,1.5,0.1,2.2 c0,0.7,0,1.5-0.1,2.2c-0.4,3.6-1.8,7-4.1,9.8c-0.9,1.2-2,2.2-3.2,3.2c-2.8,2.2-6.2,3.7-9.8,4.1c-1.5,0.2-3,0.2-4.5,0 c-3.6-0.4-7-1.8-9.8-4.1c-1.2-0.9-2.2-2-3.2-3.1c-2.1-2.7-3.5-5.8-4-9.2L71.5,335.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M125.4,307.7c-5.5-4.8-12.4-7.7-19.6-8.1v14.4c3.5,0.4,6.7,1.8,9.4,3.9L125.4,307.7z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M61.8,314.9h-9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h9c0.4,0,0.7,0.3,0.7,0.7 C62.5,314.6,62.2,314.9,61.8,314.9C61.8,314.9,61.8,314.9,61.8,314.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M64.4,309.4H52.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h11.6c0.4,0,0.7,0.3,0.7,0.7 C65.1,309.1,64.8,309.4,64.4,309.4C64.4,309.4,64.4,309.4,64.4,309.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M64.4,303.9H52.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h11.6c0.4,0,0.7,0.3,0.7,0.7 C65.1,303.6,64.8,303.9,64.4,303.9C64.4,303.9,64.4,303.9,64.4,303.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M153.7,363.4h-13.8c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h13.8c0.4,0,0.7,0.3,0.7,0.7 C154.4,363.1,154.1,363.4,153.7,363.4C153.7,363.4,153.7,363.4,153.7,363.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M157.6,357.9h-17.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h17.7c0.4,0,0.7,0.3,0.7,0.7 C158.3,357.6,158,357.9,157.6,357.9C157.6,357.9,157.6,357.9,157.6,357.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M157.6,352.4h-17.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h17.7c0.4,0,0.7,0.3,0.7,0.7 C158.3,352.1,158,352.4,157.6,352.4C157.6,352.4,157.6,352.4,157.6,352.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_vertical_chart_2_data-visualization-61"
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0_data-visualization-61",
    points: "177.5,114.7 53.8,114.7 53.8,181.1 137.1,181.1 151.4,194.8 149.8,181.1 177.5,181.1 \t"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M151.4,195.5c-0.2,0-0.4-0.1-0.5-0.2l-14.1-13.4h-83c-0.4,0-0.7-0.3-0.7-0.7v-66.4c0-0.4,0.3-0.7,0.7-0.7 h123.7c0.4,0,0.7,0.3,0.7,0.7v66.4c0,0.4-0.3,0.7-0.7,0.7h-27l1.5,12.8C152.1,195.1,151.8,195.4,151.4,195.5 C151.4,195.5,151.4,195.5,151.4,195.5L151.4,195.5z M54.5,180.5h82.6c0.2,0,0.4,0.1,0.5,0.2l12.9,12.3l-1.4-11.7 c0-0.4,0.2-0.7,0.6-0.8c0,0,0,0,0.1,0h27v-65H54.5L54.5,180.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M79.3,124.4v42.5H72v-42.5H79.3 M80.7,123H70.6v45.3h10.1L80.7,123L80.7,123z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M98.1,124.4v42.5h-7.3v-42.5H98.1 M99.5,123H89.3v45.3h10.1L99.5,123L99.5,123z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M116.8,124.4v42.5h-7.3v-42.5H116.8 M118.2,123h-10.1v45.3h10.1L118.2,123L118.2,123z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M135.6,124.4v42.5h-7.3v-42.5H135.6 M137,123h-10.2v45.3H137V123z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 145.6,
    className: "st2_data-visualization-61 targetColor",
    width: 10.1,
    height: 22.7,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.3,
    y: 136.7,
    className: "st2_data-visualization-61 targetColor",
    width: 10.1,
    height: 31.6,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.1,
    y: 157,
    className: "st2_data-visualization-61 targetColor",
    width: 10.1,
    height: 11.3,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.8,
    y: 131.3,
    className: "st2_data-visualization-61 targetColor",
    width: 10.1,
    height: 37,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M160.1,151.3h-12.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h12.4c0.4,0,0.7,0.3,0.7,0.7 C160.8,150.9,160.5,151.3,160.1,151.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M163.7,146.3h-15.9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h15.9c0.4,0,0.7,0.3,0.7,0.7 C164.4,146,164.1,146.3,163.7,146.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M163.7,141.4h-15.9c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h15.9c0.4,0,0.7,0.3,0.7,0.7 C164.4,141.1,164.1,141.4,163.7,141.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Small_Screens_data-visualization-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    y: 325.7,
    className: "st0_data-visualization-61",
    width: 66.9,
    height: 39.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M291.3,366.2h-66.9c-0.4,0-0.7-0.3-0.7-0.7l0,0v-39.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h66.9 c0.4,0,0.7,0.3,0.7,0.7v0v39.8C292,365.9,291.6,366.2,291.3,366.2L291.3,366.2z M225.1,364.8h65.5v-38.4h-65.5V364.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 216.9,
    className: "st0_data-visualization-61",
    width: 36.3,
    height: 22.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M79.7,239.7H43.4c-0.4,0-0.7-0.3-0.7-0.7v-22.2c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7V239 C80.4,239.4,80.1,239.7,79.7,239.7C79.7,239.7,79.7,239.7,79.7,239.7z M44.1,238.3H79v-20.8H44.1L44.1,238.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 137.7,
    className: "st0_data-visualization-61",
    width: 33,
    height: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M247.9,153.9h-32.9c-0.4,0-0.7-0.3-0.7-0.7v-15.5c0-0.4,0.3-0.7,0.7-0.7h32.9c0.4,0,0.7,0.3,0.7,0.7v15.5 C248.6,153.5,248.3,153.9,247.9,153.9z M215.6,152.5h31.6v-14.1h-31.6V152.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.2,
    y: 163.1,
    className: "st0_data-visualization-61",
    width: 25.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M299.1,178.5h-25.9c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-14.7c0-0.4,0.3-0.7,0.7-0.7l0,0h25.9 c0.4,0,0.7,0.3,0.7,0.7v14.7C299.8,178.2,299.5,178.5,299.1,178.5z M273.9,177.1h24.5v-13.2h-24.5L273.9,177.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.9,
    y: 205,
    className: "st0_data-visualization-61",
    width: 35.4,
    height: 23.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M453.3,229.4h-35.4c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0V205c0-0.4,0.3-0.7,0.7-0.7l0,0h35.4 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v23.8C454,229.1,453.7,229.4,453.3,229.4z M418.6,228h34v-22.3h-34V228z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M404.5,289.2h-25.5c-0.4,0-0.7-0.3-0.7-0.7v0v-13.7c0-0.4,0.3-0.7,0.7-0.7h0h25.5c0.4,0,0.7,0.3,0.7,0.7v0 v13.8C405.2,288.9,404.8,289.2,404.5,289.2z M379.6,287.8h24.1v-12.4h-24.1V287.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.6,
    y: 252.2,
    className: "st0_data-visualization-61",
    width: 25.5,
    height: 13.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M439.2,266.7h-25.5c-0.4,0-0.7-0.3-0.7-0.7v0v-13.7c0-0.4,0.3-0.7,0.7-0.7l0,0h25.5c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0V266C439.9,266.4,439.6,266.7,439.2,266.7z M414.4,265.3h24.1v-12.4h-24.1V265.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line_Graphics_data-visualization-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M101.5,275.5H86.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h15.4c0.4,0,0.7,0.3,0.7,0.7 C102.2,275.1,101.9,275.5,101.5,275.5C101.5,275.5,101.5,275.5,101.5,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M120.4,200.4h-12.4c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h12.4c0.4,0,0.7,0.3,0.7,0.7 C121.1,200.1,120.8,200.4,120.4,200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M291.3,141.4h-13c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h13c0.4,0,0.7,0.3,0.7,0.7 C292,141.1,291.6,141.4,291.3,141.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_vertical_chart_data-visualization-61"
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0_data-visualization-61",
    points: "456.6,125.5 334,125.5 334,184.1 355.5,184.1 354.9,199.7 368.1,184.1 456.6,184.1 \t"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1_data-visualization-61",
    d: "M354.9,200.4c-0.1,0-0.2,0-0.2,0c-0.3-0.1-0.5-0.4-0.5-0.7l0.5-14.9H334c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0 v-58.7c0-0.4,0.3-0.7,0.7-0.7l0,0h122.6c0.4,0,0.7,0.3,0.7,0.7v0v58.6c0,0.4-0.3,0.7-0.7,0.7l0,0h-88.2l-12.9,15.3 C355.3,200.4,355.1,200.4,354.9,200.4z M334.7,183.4h20.8c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5l-0.5,13.6l11.8-14 c0.1-0.2,0.3-0.2,0.5-0.2h87.9v-57.3H334.7V183.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M363.6,173.5h-9.2c-0.4,0-0.7-0.3-0.7-0.7v-9.2c0-0.4,0.3-0.7,0.7-0.7l0,0h9.2c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v9.2C364.3,173.2,364,173.5,363.6,173.5z M355.1,172.1h7.8v-7.8h-7.8V172.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M381.6,173.5h-9.2c-0.4,0-0.7-0.3-0.7-0.7v-14.7c0-0.4,0.3-0.7,0.7-0.7l0,0h9.2c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v14.7C382.3,173.2,382,173.5,381.6,173.5L381.6,173.5z M373.1,172.1h7.8v-13.3h-7.8V172.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M399.6,173.5h-9.2c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-23.2c0-0.4,0.3-0.7,0.7-0.7l0,0h9.2 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v23.2C400.3,173.2,400,173.5,399.6,173.5L399.6,173.5z M391.1,172.1h7.8v-21.8h-7.8V172.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3_data-visualization-61",
    d: "M417.6,173.5h-9.2c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-31.1c0-0.4,0.3-0.7,0.7-0.7l0,0h9.2 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v31.1C418.3,173.2,418,173.5,417.6,173.5L417.6,173.5z M409.1,172.1h7.8v-29.6h-7.8V172.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 426.4,
    y: 135.6,
    className: "st2_data-visualization-61 targetColor",
    width: 9.2,
    height: 37.2,
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M435.6,173.5h-9.2c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-37.2c0-0.4,0.3-0.7,0.7-0.7l0,0h9.2 c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v37.2C436.3,173.2,436,173.5,435.6,173.5z M427.1,172.1h7.8v-35.8h-7.8V172.1z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_data-visualization-61 targetColor",
    d: "M446.7,173.5H347c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h99.8c0.4,0,0.7,0.3,0.7,0.7 S447.2,173.5,446.7,173.5C446.8,173.5,446.8,173.5,446.7,173.5L446.7,173.5z",
    style: {
      fill: "rgb(219, 50, 54)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataVisualization);
export default __webpack_public_path__ + "static/media/data-visualization.a8297c1db6bab6965e402804f5799d6a.svg";
export { ForwardRef as ReactComponent };